import { useEffect, useRef, useState } from 'react'
import { reportActivity, type Session } from '../api/client'

export default function SessionMonitor({ session, onUpdate, enabled = true }: { session: Session; onUpdate: (next: Session) => void; enabled?: boolean }) {
  const [now, setNow] = useState(Date.now()), [error, setError] = useState('')
  const lastSent = useRef(0), pending = useRef(false), latest = useRef(session)
  latest.current = session
  const update = useRef(onUpdate); update.current = onUpdate
  const acceptingActivity = useRef(enabled); acceptingActivity.current = enabled
  useEffect(() => {
    let active = true
    const activity = (event: Event) => {
      if (!acceptingActivity.current || event.target instanceof Element && event.target.closest('[data-session-activity="ignore"]')) return
      if (document.visibilityState !== 'visible' || pending.current || Date.now() - lastSent.current < 60000) return
      pending.current = true; lastSent.current = Date.now()
      void reportActivity().then(next => { if (active) { update.current(next); setError('') } }).catch(() => { if (active) setError('连接暂时中断，登录状态将在恢复后重新校验。') }).finally(() => { pending.current = false })
    }
    const timer = window.setInterval(() => {
      const at = Date.now(); setNow(at)
      if (at >= Math.min(latest.current.expiresAt, latest.current.idleExpiresAt ?? Infinity)) window.dispatchEvent(new Event('kb:session-expired'))
    }, 1000)
    const events = ['pointerdown', 'keydown', 'scroll']
    for (const event of events) window.addEventListener(event, activity, { passive: true })
    return () => { active = false; clearInterval(timer); for (const event of events) window.removeEventListener(event, activity) }
  }, [session.sessionId])
  const absoluteSeconds = Math.ceil((session.expiresAt - now) / 1000)
  const idleSeconds = Math.ceil(((session.idleExpiresAt ?? Infinity) - now) / 1000)
  return <>{error ? <div className="note warn" role="status">{error}</div> : null}{absoluteSeconds <= 300 ? <div className="note warn" role="status">本次登录将在 {Math.max(0, Math.ceil(absoluteSeconds / 60))} 分钟内到期，请保存当前工作后重新登录。</div> : idleSeconds <= 120 ? <div className="note warn" role="status">长时间未操作，将在 {Math.max(0, idleSeconds)} 秒后退出登录。继续操作可保持登录。</div> : null}</>
}
